import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

export const IntroductionSection: React.FC = () => {
  return (
    <Doc.Section title="Introduction">
      <p>
        Entia Liberty is comprised of a connected blood count analyser for patients to self-test in the comfort of their
        own home. The device measures haemoglobin, total white blood cell count, neutrophil count and platelet count
        from a finger prick sample.
      </p>
      <p>
        Once analysed, the results will be automatically shared with healthcare professionals to interpret via the Entia
        Liberty Dashboard in hospitals.
      </p>
    </Doc.Section>
  );
};
